import React, { forwardRef } from 'react';

import { EVENT_ENUMS } from '@vlabs/api-bindings/src/luna-client/constants';
import { ControlledColorFilter } from '@vlabs/monokit/shared/ui/controlled-color-filter';
import { ControlledOptionsFilter } from '@vlabs/monokit/shared/ui/controlled-options-filter';
import type { Option } from '@vlabs/monokit/shared/ui/options-filter';
import { PopoverWithButton } from '@vlabs/monokit/shared/ui/popovers';
import type { PopoverWithButtonProps } from '@vlabs/monokit/shared/ui/popovers';
import { useTranslation } from 'react-i18next';

import { useWorkspaceFilters } from '../../useWorkspaceFilters';
import st from '../FilterPopovers.module.sass';

function LowerFilterPopover(
  props: PopoverWithButtonProps,
  ref: React.ForwardedRef<HTMLDivElement>,
): React.JSX.Element {
  const { t } = useTranslation();
  const { filters, updateFilters } = useWorkspaceFilters();
  const colors = filters.lower_garment_colors ?? [];
  const types = filters.lower_garment_types ?? [];
  const colorOptions = EVENT_ENUMS.LOWER_BODY.LOWER_GARMENT.COLORS.raw as Option[];
  const typeOptions = EVENT_ENUMS.LOWER_BODY.LOWER_GARMENT.TYPE.raw as Option[];

  const reset = () => updateFilters({
    lower_garment_colors: undefined,
    lower_garment_types: undefined,
  });

  return (
    <PopoverWithButton
      {...props}
      isButtonDisabled={colors.length === 0 && types.length === 0}
      onClickReset={reset}
      ref={ref}
    >
      <ControlledColorFilter
        label={t('events:bottom_colors')}
        onChange={(value) => updateFilters({
          lower_garment_colors: value.length > 0 ? value : undefined,
        })}
        options={colorOptions}
        value={colors}
      />
      <div className={st.SectionDivider} />
      <ControlledOptionsFilter
        label={t('events:bottom_type')}
        name="lower_garment_types"
        onChange={(value) => updateFilters({
          lower_garment_types: value.length > 0 ? value : undefined,
        })}
        options={typeOptions}
        value={types}
      />
    </PopoverWithButton>
  );
}

const LowerFilterPopoverWithRef = forwardRef(LowerFilterPopover);
export { LowerFilterPopoverWithRef as LowerFilterPopover };
